import React from 'react';
import { Button, Dialog, DialogContent, DialogTitle, Grid } from 'src/components';
import BaseComponent from 'src/core/base.component';
import EImzaLoginRaporDogrulamaAramaKriterleri from './AramaKriterleri';
import EImzaLoginRaporDogrulamaListe from './Liste';
import { Breakpoint } from '@mui/system';
import { translate } from 'src/i18n/tHelper';

export interface EImzaLoginRaporDogrulamaProps {
    open?: boolean;
    onClose?: () => void;
    fullWidth?: boolean;
    maxWidth?: Breakpoint;
    height?: string | number;
}

const EImzaLoginRaporDogrulama = (props: EImzaLoginRaporDogrulamaProps): JSX.Element => {

    const closeHandlerClick = (e) => {
        if (props.onClose)
            props.onClose();
    };

    return (
        <BaseComponent>
            <Dialog
                open={props.open}
                onClose={(e, r) => {
                    if (props.onClose)
                        props.onClose();
                }}
                fullWidth={props.fullWidth}
                maxWidth={props.maxWidth}
            >
                <DialogTitle>{translate("pages|login", "LBYS Rapor Doğrulama (e-İmza)")}</DialogTitle>
                <DialogContent>
                    <Grid container justifyContent="right">
                        <Grid item>
                            <EImzaLoginRaporDogrulamaAramaKriterleri {...props} />
                        </Grid>
                        <Grid item>
                            <EImzaLoginRaporDogrulamaListe {...props} />
                        </Grid>
                        <Grid item md={4}>
                            <Button customType="close" onClick={closeHandlerClick} />
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </BaseComponent>
    )
}

export default EImzaLoginRaporDogrulama;